import { Indicator, MantineColor } from '@mantine/core';
import { ReactNode } from 'react';

interface PulsingIconProps {
  children: ReactNode;
  color?: MantineColor;
  size?: number;
}

export const IndicatorMark = ({ children, color = 'orange' }: PulsingIconProps) => {
  return (
    <Indicator
      color={color}
      processing
      styles={{
        indicator: {
          zIndex: 0,
        },
      }}
    >
      {children}
    </Indicator>
  );
};
